import React, { useState, useEffect, lazy, Suspense } from "react";
import "./partnerCompanies.css";
import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { PartnerCompanyList } from "../../components/datatable/PartnerCompanyList";
import { getPartnerCompanies } from "../../interpreter/partner";
import { useAuth } from "../../contexts/authContexts";

const UserModal = lazy(() => import("../../components/modals/profileUser"));
const CreatePartnerCompanyModal = lazy(() => import("../../components/modals/createPartnerCompany"));
const EditPartnerCompanyModal = lazy(() => import("../../components/modals/editPartnerCompany"));
const PermissionDeniedModal = lazy(() => import("../../components/modals/denegPermisse"));

const PartnerCompanies = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const { user } = useAuth();
  const tienePermiso = user?.permissions?.some((p) => p.name === "manage-partners");

  useEffect(() => {
    if (!tienePermiso) setShowPermissionModal(true);
  }, [tienePermiso]);

  const fetchCompanies = async () => {
    try {
      const data = await getPartnerCompanies(false);
      setCompanies(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al obtener empresas partner:", error);
      setCompanies([]);
    }
  };

  useEffect(() => {
    if (tienePermiso) fetchCompanies();
  }, [tienePermiso]);

  const openModal = (modalType, company) => {
    setSelectedCompany(company);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedCompany(null);
  };

  const handleSuccess = () => {
    fetchCompanies();
    closeModal();
  };

  const closePermissionModal = () => {
    setShowPermissionModal(false);
    window.history.back();
  };

  return (
    <div className="flex h-screen">
      <Headers />

      <MainContent>
        <HeadersCentral showDropdown={showDropdown} setShowDropdown={setShowDropdown} openModal={() => openModal("user")} />

        <main className="p-4 sm:p-6 overflow-x-hidden">
          <h1 className="text-3xl font-bold mb-6 flex items-center gap-3 text-gray-800">
            <svg className="w-8 h-8 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
              <path d="M19 4h-1a2 2 0 00-2-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v2a2 2 0 00-2 2v1a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2zm0 14H2V8h2v8h2V8h2v8h2V8h2v8h2V8h2v10z" />
            </svg>
            Empresas Partner
          </h1>

          <div className="mb-4">
            <button
              onClick={() => openModal("create")}
              className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg shadow"
            >
              <span>+</span> Nueva empresa
            </button>
          </div>

          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg overflow-hidden min-w-0">
            <PartnerCompanyList companies={companies} openModal={openModal} onRefresh={fetchCompanies} />
          </div>
        </main>
      </MainContent>
      <Suspense fallback={null}>
        {showPermissionModal && (
          <PermissionDeniedModal isOpen={showPermissionModal} onClose={closePermissionModal} />
        )}
        {activeModal === "user" && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === "create" && (
          <CreatePartnerCompanyModal isOpen={true} onClose={closeModal} onSuccess={handleSuccess} />
        )}
        {activeModal === "edit" && (
          <EditPartnerCompanyModal isOpen={true} onClose={closeModal} company={selectedCompany} onSuccess={handleSuccess} />
        )}
      </Suspense>
    </div>
  );
};

export default PartnerCompanies;
